import { lighten } from "@mui/system";

const styles = (theme) => ({
  title: { fontWeight: "bold", fontSize: "20px" },
  paperContainer: {
    margin: "10px 0",
    p: 2,
    borderRadius: "16px",
  },
  paperForm: {
    mt: 1,
    borderRadius: 2,
    p: 1,
  },
  boxPaperForm: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 1,
  },
  boxIconSelect: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  boxTitleConfig: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  boxIconForm: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  campoForms: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  boxTextfieldForm: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    p: 1.5,
    borderRadius: 2,
    bgcolor: "action.hover",
    border: `1px solid ${theme.palette.divider}`,
  },
  boxFormFieldHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  formFieldIndexLabel: {
    fontWeight: 700,
    fontSize: "0.75rem",
    color: "primary.main",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
  },
  formFieldTopRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    flexWrap: "wrap",
    width: "100%",
  },
  formFieldDescription: {
    width: "100%",
    "& .MuiInputBase-root": {
      fontSize: "0.85rem",
    },
  },
  formFieldDescriptionIcon: {
    mr: 1,
    mt: "2px",
    alignSelf: "flex-start",
  },
  switch: {
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 0.2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: theme.palette.primary.main,
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "dark"
            ? theme.palette.grey[600]
            : theme.palette.grey[100],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "dark" ? 0.3 : 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor:
        theme.palette.mode === "dark"
          ? lighten(theme.palette.colors.black.dark, 0.07)
          : theme.palette.colors.gray.medium,
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  },
  icon: {
    fontSize: 22,
    color: theme.palette.white.main,
  },
  titleSwitch: {
    fontWeight: 600,
    ml: 1,

    fontSize: "0.85rem",
    userSelect: "none",
  },
  paperDatagrid: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    height: "100%",
    maxHeight: "400px",
  },
  searchField: {
    width: "100%",
    maxWidth: 300,

    display: "flex",

    fontSize: "0.75rem", // diminui fonte geral
    "& .MuiInputBase-input": {
      padding: "8px 8px", // padding interno reduzido
      fontSize: "0.75rem", // fonte do input
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.75rem", // fonte da label
    },
    "@media (max-width: 1350px)": {
      width: "100%",
    },
  },
  paperBody: {
    p: 3,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    backgroundColor: theme.palette.background.wallpaper,
  },
  paperItemConfig: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    p: 2,
    borderRadius: "16px",
  },
  boxMainConfig: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    width: "100%",
  },

  subtitle: {
    fontSize: "13px",
    color: "text.secondary",
    lineHeight: 1.4,
  },
  containerInfoConfig: { display: "flex", gap: 1, width: "100%" },
  autocompleteInfoConfig: {
    width: "100%",
    maxWidth: 400,
  },
  containerHeader: {
    p: 1,
  },
  paperDescription: {
    p: 1.5,
    flex: 1,
    borderRadius: "8px",
    bgcolor: "action.hover",
    display: "flex",
    alignItems: "center",
    minHeight: "48px",
    borderStyle: "dashed",
  },
  boxActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    mt: 2,
  },
  headerTitleBox: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  boxLoading: {
    display: "flex",
    justifyContent: "center",
    p: 4,
  },
  boxEditActions: {
    display: "flex",
    gap: 1,
  },
  buttonAddConfig: {
    mt: 2,
    border: "1px dashed",
    color: theme.palette.primary.main,
  },
  boxFormsHeaderText: {
    p: 1,
  },
  textItalicCenter: {
    fontStyle: "italic",
    textAlign: "center",
    py: 1,
  },
  boxEmptyState: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 100,
  },
  textItalic: {
    fontStyle: "italic",
  },
  permissaoSelectorPaper: {
    p: 2,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  permissaoSelectorHeaderBox: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  permissaoSelectorContainer: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    flexWrap: "wrap",
    mt: 0.5,
  },
  permissaoAutocomplete: {
    width: "100%",
    maxWidth: 400,
  },
  permissaoOption: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  permissaoColorDot: {
    width: 14,
    height: 14,
    minWidth: 14,
    borderRadius: "50%",
  },
  chipSelectedPermissao: {
    color: theme.palette.white.main,
    fontWeight: 600,
  },
  formFieldName: {
    flex: "2 1 200px",
  },
  formFieldType: {
    flex: "1 1 160px",
  },
});
export default styles;
